// extracted by mini-css-extract-plugin
export default {"offlineBanner":"OfflineBanner_offlineBanner__Wf5Zr"};